import React from 'react';

interface DateRangePickerProps {
  dateFrom: string;
  dateTo: string;
  onDateFromChange: (value: string) => void;
  onDateToChange: (value: string) => void;
  label?: string;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  label = 'Zakres dat',
}) => {
  const setQuickRange = (days: number) => {
    const to = new Date();
    const from = new Date();
    from.setDate(from.getDate() - days);
    onDateFromChange(from.toISOString().split('T')[0]);
    onDateToChange(to.toISOString().split('T')[0]);
  };

  const setThisMonth = () => {
    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth(), 1);
    onDateFromChange(from.toISOString().split('T')[0]);
    onDateToChange(now.toISOString().split('T')[0]);
  };

  const setLastMonth = () => {
    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const to = new Date(now.getFullYear(), now.getMonth(), 0);
    onDateFromChange(from.toISOString().split('T')[0]);
    onDateToChange(to.toISOString().split('T')[0]);
  };

  const clearDates = () => {
    onDateFromChange('');
    onDateToChange('');
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
      <input
        type="date"
        className="form-control"
        value={dateFrom}
        onChange={(e) => onDateFromChange(e.target.value)}
        style={{ width: '140px', fontSize: '12px', padding: '6px 8px' }}
        title="Od"
      />
      <span style={{ color: 'var(--text-muted)', fontSize: '12px' }}>—</span>
      <input
        type="date"
        className="form-control"
        value={dateTo}
        onChange={(e) => onDateToChange(e.target.value)}
        style={{ width: '140px', fontSize: '12px', padding: '6px 8px' }}
        title="Do"
      />
      <div style={{ display: 'flex', gap: '2px' }}>
        {[
          { label: '7d', action: () => setQuickRange(7) },
          { label: '30d', action: () => setQuickRange(30) },
          { label: 'Miesiąc', action: setThisMonth },
          { label: 'Poprz.', action: setLastMonth },
        ].map((q) => (
          <button
            key={q.label}
            type="button"
            className="btn btn-link btn-sm"
            onClick={q.action}
            style={{ fontSize: '10px', padding: '2px 6px', whiteSpace: 'nowrap' }}
          >
            {q.label}
          </button>
        ))}
        {(dateFrom || dateTo) && (
          <button
            type="button"
            className="btn btn-link btn-sm"
            onClick={clearDates}
            style={{ fontSize: '10px', padding: '2px 6px', color: '#ef4444' }}
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default DateRangePicker;
